import * as axios from 'axios'
import { ARCGIS_LAYER_VERSION_TAG } from '../lib/constants'
import { getConfig } from '../lib/config'
import { getAuthHeaders } from '../lib/request'
import { userRequest } from '../lib/userRequest'

export const getLayerForState = async stateName => {  
  const baseURL = getConfig('SERVER_ARC_GIS')
  const headers = getAuthHeaders()
  const url = `/rest/services/Hosted/${stateName}${ARCGIS_LAYER_VERSION_TAG}/FeatureServer/layers?f=pjson`

  return axios({
    baseURL,
    headers,
    url
  })
    .then(response => {
      return {
        success: true,
        stateName,
        data: response.data
      }
    })
    .catch(error => {
      return { success: false, data: error }
    })
}

export const getAllLayers = async () => {
  const queryParams = {}

  // Request the web-scoped manifest. Off unless the config explicitly says true, so a
  // missing key or a stringified "false" both leave the unscoped request in place.
  if (getConfig('WEB_LAYERS_MANIFEST_ENABLED') === true) {
    queryParams.client = 'web'
  }

  return userRequest('get', '/layers-manifest', queryParams, false, {}, true)
}
